// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "site-assets/js/" + chunkId + "." + {"53":"05c658bf3cc58179","836":"167f05f09d94b47a"}[chunkId] + ".js";
};